// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1c1Bf","footer":"ModalUpdate_footer__1QdNs"};